{
 "name": "0_plant_mushroom4",
 "bin": "0_plant_mushroom4.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Group01", "parent": 1, "t": [0.09531403,-44.79058,-8.621846e-07], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "", "parent": 10, "t": [-10.17584,44.79058,0], "q": [0,-0,-0.1736482,0.9848078], "s": [1,1,1]},
  {"name": "0_mushroom4", "parent": 10, "t": [-0.09532166,70.30412,0], "q": [6.324836e-08,0.7071067,0.7071069,-1.250656e-07], "s": [0.9999999,1,0.9999999]}
 ],
 "parts": [
  {"node": 12, "vertexCount": 324, "posOffset": 0, "nrmOffset": 3888, "uvOffset": 7776, "material": "0_plant_mushroom3", "color": [1,0,0,1], "texture": "0_plant_mushroom_4.png"}
 ],
 "anims": [
  {"name": "die", "duration": 0.8, "fps": 30, "frames": 25, "offset": 10368},
  {"name": "grow", "duration": 3.3, "fps": 30, "frames": 100, "offset": 23368},
  {"name": "idle", "duration": 0.8, "fps": 30, "frames": 25, "offset": 75368},
  {"name": "pick", "duration": 0.96667, "fps": 30, "frames": 30, "offset": 88368}
 ]
}
